import type { LoggerConfigType } from '@/types/LoggerConfigType';
import type { StickyFieldsType } from '@/types/StickyFieldsType';

export const SummerFieldDayLoggerConfig: LoggerConfigType = {
  templateId: 'ARRL_FD',
  templateDescription: 'ARRL Field Day',
  toolbarItems: ['TIME', 'FREQUENCY', 'MODE', 'TX_POWER', 'MY_CALLSIGN', 'MY_LOCATION', 'MY_CLASS', 'MY_SECTION'],
  toolbarPosition: 'TOP',
  panels: ['QSO_MAP'],
  tableColumns: ['qsoDateTime', 'call', 'class', 'arrlSect', 'freq', 'band', 'mode', 'qrzcomQsoUploadStatus'],
  dupeCheckFields: ['call', 'mode', 'band'],
  stickyFields: [
    "freq",
    "band",
    "myGridsquare",
    "mode",
    "txPwr",
    "myCnty",
    "myState",
    "operator",
    "stationCallsign",
    "myArrlSect",
    "appHamrsMyClass"
  ] as unknown as StickyFieldsType[],
  fieldRows: [
    {
      columns: { base: 4 },
      fields: [
        { component: 'TheirCall', columns: { base: 2 } },
        { component: 'TextField', columns: { base: 1 }, props: { field: "class", label: "Their Class" } },
        { component: 'TextField', columns: { base: 1 }, props: { field: "arrlSect", label: "Their Section" } },
      ]
    },
    {
      columns: { base: 2 },
      fields: [
        { component: 'Comments' },
        { component: 'Notes' },
      ]
    },
    {
      fields: [
        { component: 'OperatorBar' }
      ]
    },
    {
      classes: "flex justify-end",
      fields: [
        { component: 'ClearButton' },
        { component: 'SaveButton' },
      ]
    }
  ],
}

export default SummerFieldDayLoggerConfig;
